import { AgencyConstants } from 'features/Agency/agencyHelper';
import AppConstants from 'general/constants/AppConstants';
import { useMemo } from 'react';

useCharge.propTypes = {};

function useCharge(props) {
  // MARK: ---- PROPERTIES ----
  // doi tuong quan ly tram sac
  const managementObjectOptions = [
    { name: 'Nhà điều hành', value: AppConstants.userRole.admin },
    { name: 'NĐT nhượng quyền', value: AgencyConstants.AgencyRole.INVESTOR },
    { name: 'Dự án HTKD', value: AgencyConstants.AgencyRole.LANDLORD },
  ];

  return useMemo(() => {
    return {
      managementObjectOptions,
    };
  }, []);
}

export default useCharge;
